module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA2klEQVQ4T2NkgIL/FS4OMDaIZuzYcwDG/7SOV5jjD7sCsvwPlp8P+II+v2UECf6vdN3PwMiAYgDDf4YDjO27HcGa/7PdZGBgFEY2gIHh/9sfjL/UGcE2MzHuR5WE8v79d/xtdOEzAzPDGazyfxlMhoMBFAciVaIRZEjAYQmUaNxg+wKeDkDyBpNfo8hfyBUFy4PTQeARyf2MDIwoCv4z/D+w3ua5I0jecPK7/YwM/9HkGQ+czxVyZATZzMTIhDUd/Pv/z/HBhcsMTAw45Bn+DQsDKA5EWDogNxoBz+ey9YwzePgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/服务.png
// module id = g+My
// module chunks = 15